import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { WrapperTabs, SectionCheckBox, SectionPanel } from './styles';
import { TabPanel, a11yProps } from './utils';
import {getReportes, searchMultiReports, searchDelete} from "../../../../app/store/fuse/reportes";
import {useDispatch} from "react-redux";


const TabsReport = () => {
  const [value, setValue] = useState(0);
  const [search, setSearch] = useState(null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const dispatch = useDispatch();
  const searchReportes = (data) => dispatch(searchMultiReports(data));
  const initReportes = () => dispatch(getReportes());
  const deleteSearch = (data) => dispatch(searchDelete(data));

  const getReportesTabs = (event) => {
    initReportes()
    let labelText = event.target.labels[0].textContent
    let val= event.target.checked
    const dataSearch = !labelText ? search : labelText;
    if(val){
      setTimeout(() => {
        searchReportes(dataSearch)
      },500)
    }else{
      setTimeout(() => {
        deleteSearch(dataSearch)
      },500)
    }
    setSearch(null);
  };
  
  const dataReport = {
    ReporteBasico: {
      title: 'Reportes Básicos',
      data: [
        {
          name: 'Disponibilidad',
          value: 'disponibilidad',
        },
        {
          name: 'Ancho de Banda',
          value: 'ancho_de_banda',
        },
        {
          name: 'Paquetes',
          value: 'paquetes',
        },
        {
          name: 'Memoria/CPU',
          value: 'memoria_cpu',
        },
      ],
    },
    ReporteMedios: {
      title: 'Reportes Medios',
      data: [
        {
          name: 'Tráfico',
          value: 'trafico',
        },
        {
          name: 'Conversaciones',
          value: 'conversaciones',
        },
        {
          name: 'Indices',
          value: 'indices',
        },
        {
          name: 'Alertas',
          value: 'alertas',
        },
      ],
    },
    ReportesAvanzados: {
      title: 'Reportes Avanzados',
      data: [
        {
          name: 'Tiempo de Respuesta',
          value: 'tiempo_de_respuesta',
        },
        {
          name: 'Trafico',
          value: 'trafico',
        },
        {
          name: 'Ancho de Banda',
          value: 'ancho_de_banda',
        },
        {
          name: 'Máximo RTT',
          value: 'alertas',
        },
        {
          name: 'Planeación capacidad',
          value: 'planeacion_capacidad',
        },
      ],
    },
  };

  return (
    <WrapperTabs>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Reportes" {...a11yProps(0)} />
          </Tabs>
        </Box>

        <SectionPanel>
          <TabPanel value={value} index={5} className="section-tab">
            Sin disponibilidad
          </TabPanel>
        </SectionPanel>

        <SectionPanel>
          <TabPanel value={value} index={1} className="section-tab">
            Sin tráfico
          </TabPanel>
        </SectionPanel>

        <SectionPanel>
          <TabPanel value={value} index={2} className="section-tab">
            Sin recursos
          </TabPanel>
        </SectionPanel>

        <SectionPanel>
          <TabPanel value={value} index={3} className="section-tab">
            Sin indicadores
          </TabPanel>
        </SectionPanel>

        <SectionPanel>
          <TabPanel value={value} index={4} className="section-tab">
            Sin alertas
          </TabPanel>
        </SectionPanel>

        <SectionPanel>
          <TabPanel value={value} index={0} className="section-tab">
            <SectionCheckBox>
              <FormGroup>
                <strong>{dataReport.ReporteBasico.title}</strong>
                {dataReport.ReporteBasico.data.map((data, index) => (
                  <div key={index}>
                    <FormControlLabel control={<Checkbox onClick={() => getReportesTabs(event)}/>} label={data.name} />
                  </div>
                ))}
              </FormGroup>
            </SectionCheckBox>
          </TabPanel>
        </SectionPanel>
        <div className="section-button">
          <Button variant="contained" color="info">
            Mostrar Lista
          </Button>
        </div>
      </Box>
    </WrapperTabs>
  );
};

export default TabsReport;

